import { render, staticRenderFns } from "./UserTrainingCourseTable.vue?vue&type=template&id=79e68214&"
import script from "./UserTrainingCourseTable.vue?vue&type=script&lang=js&"
export * from "./UserTrainingCourseTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports